import { useTranslation } from 'react-i18next';
import CloseIcon from '../../images/close_icon.png';
import { callIfMouseSupported, callIfTouchSupported, callIfPointerSupported } from '../General/EventSupport';
import { useEffect, useState } from 'react';
import { Uploader } from '../Uploader/Uploader';
import UserService from '../Keycloak/UserService';
import JobHistoryElement from './JobHistoryElement';
import PolygonIcon from '../../images/polygon_icon.png'
import './JobHistory.less';

const JobHistory = ({
  onClickClose = () => {},
}) => {
  const { t } = useTranslation();
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [filterTag, setFilterTag] = useState({"Title": 0, "Filter":null});
  const [filterTags] = useState([
    {"Title": 0, "Filter":null},
    {"Title": 1, "Filter":{ days: 30 }}, 
    {"Title": 2, "Filter":{ days: 7 }}, 
    {"Title": 3, "Filter":{ hours: 24 }}
  ]);

  const getJobhistory = () => {
    Uploader.getJobhistoryForUser(UserService.SessionData.getUserID()).then((res) => {
      if(res.Success === false) return;
      setJobs(res.Jobhistory);
      setFilteredJobs(filterByTimeInterval(res.Jobhistory, 'Uploaded', filterTag.Filter) || res.Jobhistory);
    });
  };

  const stopEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const removeTrailingUnderscore = (str) => {
    if (str && typeof str === 'string' && str.endsWith("_")) {
      return str.slice(0, -1);
    }

    return str;
  };

  const filterByTimeInterval = (items, dateKey, interval = {}) => {
  /**
   * Filtert ein Array von Elementen anhand eines Datumsfelds im Format "YYYY-MM-DD HH:MM:SS"
   * @param {Array} items - Array der Elemente, die ein Datumsfeld enthalten
   * @param {string} dateKey - Der Schlüsselname, unter dem das Datum gespeichert ist (z. B. 'createdAt')
   * @param {Object} interval - Zeitintervall, z. B. { days: 30 } oder { hours: 24 }
   * @returns {Array} Gefilterte Elemente, die innerhalb des Zeitintervalls liegen
  */

    if (!items || !items.length) return [];

    if (!dateKey || !interval) return items;

    const now = new Date();
    let msOffset = 0;

    // Berechnung der Millisekunden entsprechend dem angegebenen Intervall
    if (interval.days) msOffset += interval.days * 24 * 60 * 60 * 1000;
    if (interval.hours) msOffset += interval.hours * 60 * 60 * 1000;
    if (interval.minutes) msOffset += interval.minutes * 60 * 1000;

    const threshold = new Date(now.getTime() - msOffset);

    return items.filter(item => {
      const itemDate = new Date(item[dateKey].replace(' ', 'T'));
      return itemDate >= threshold;
    });
  };

  const getFilterTitle = (index) => {
    switch (index) {
      case 0:
        return t('JobHistoryNoFilter');
      case 1:
        return t('JobHistoryFilter30Days');
      case 2:
        return t('JobHistoryFilter7Days');
      case 3:
        return t('JobHistoryFilter24Hours');
      default:
        return t('JobHistoryNoFilter');
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    //NOTE:component mount
    getJobhistory();

    return () => {
      //NOTE: component unmount
    };
  },[]); // <- läuft bei jedem Mount neu (wenn vorher unmounted wurde)
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    setFilteredJobs(filterByTimeInterval(jobs, 'Uploaded', filterTag.Filter) || jobs);
  }, [filterTag,jobs]);

  return (
    <div
      className="job_history_container"
      onClick={stopEvent}
      onPointerDown={(e) => e.stopPropagation()}
      onPointerUp={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      onTouchEnd={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onScroll={(e) => e.stopPropagation()}
    >
      <div className='job_history_overlay'>
        <div className='job_history_header'>
          <div className='job_history_header_left'>
            <label>{t('JobHistory')}</label>
            <div className='filter_dropdown_container' onMouseLeave={() => setDropdownOpen(false)}>
                <button 
                    className={"armodelviewer_button " + (dropdownOpen ? 'filter_dropdown_button_open' : 'filter_dropdown_button')} 
                    onPointerUp={(e) => {
                      callIfPointerSupported(() => setDropdownOpen(!dropdownOpen), e)
                      e.preventDefault();
                    }}
                    onTouchStart={(e) => {
                      callIfTouchSupported(() => setDropdownOpen(!dropdownOpen))
                      e.preventDefault();}}
                    onMouseUp={(e) => {
                      callIfMouseSupported(() => setDropdownOpen(!dropdownOpen), e)
                      e.preventDefault();}}
                    title={t('JobHistoryFilter')}>
                        {(filterTag ? getFilterTitle(filterTag.Title) : "") + "        "}
                        <img src={PolygonIcon} className={dropdownOpen ? "polygon_opened" : "polygon_closed"} alt={t('Dropdown')}/>
                </button>
                <div className='filter_dropdown' style={{visibility: dropdownOpen ? "visible" : "hidden"}}>
                    {filterTags.map((tag, idx) => {  
                        return <div className='filter_dropdown_element' key={'filter_dropdown_element' + idx}>
                            <button 
                              onPointerUp={(e) => {
                                callIfPointerSupported(() => setFilterTag(tag), e)
                                e.preventDefault();
                              }}
                              onTouchStart={(e) => {
                                callIfTouchSupported(() => setFilterTag(tag))
                                e.preventDefault();}}
                              onMouseUp={(e) => {
                                callIfMouseSupported(() => setFilterTag(tag), e)
                                e.preventDefault();}}
                              title={t('JobHistoryFilterAccordingTo') + " " + getFilterTitle(tag.Title)}
                            >
                                <label>{tag ? getFilterTitle(tag.Title) : ""}</label>
                            </button>
                        </div>
                    })}
                </div>
            </div>
          </div>
          <div className='job_history_header_right'>
            <button 
              title={t('Close')}
              className='close_button'
              onPointerUp={(e) => {
                callIfPointerSupported(() => onClickClose(e), e)
                e.preventDefault();
              }}
              onTouchStart={(e) => {
                callIfTouchSupported(() => onClickClose(e))
                e.preventDefault();}}
              onMouseUp={(e) => {
                callIfMouseSupported(() => onClickClose(e), e)
                e.preventDefault();}}
            >
              <img src={CloseIcon} alt={t('Close')}/>
            </button>
          </div>
        </div>
        <div className='job_history_body'>
          <div className='job_history_list_container'>
            <div className='job_history_list'>
              {filteredJobs && filteredJobs.map((job, index) => (
                <JobHistoryElement 
                  key={index} failed={job.State === -1} 
                  name={removeTrailingUnderscore(job.FileName) + job.FileType} 
                  date={job.Uploaded} 
                  messages={job.Errors}
                  itemID={job.ItemID}
                />
              ))}
            </div>
          </div>
        </div>
        <div className='job_history_footer'>
          <label>{t('JobHistoryFooter')}</label>
        </div>
      </div>
    </div>
  );
};

export default JobHistory;